<template>
        <card>
        <template slot="header">
            <h4 class="card-title pb-5p">{{i18nValues['rankingOpenRate']}}</h4>
        </template>
        <el-tabs v-model="tabRankName" tab-position="bottom" stretch class="dashBoardTabs">
            <el-tab-pane :label="i18nValues['ratio']" name="ratio">
                  <HorizontalBarChart
                    :height="300"
                    :labels="openRatioBar.labels"
                    :datasets="openRatioBar.datasets"
                ></HorizontalBarChart>
                <div class="stats" slot="footer">
        </div>
            </el-tab-pane>
            <el-tab-pane :label="i18nValues['quantity']" name="quantity">
                <HorizontalBarChart
                    :height="300"
                    :labels="openQtyBar.labels"
                    :datasets="openQtyBar.datasets"
                ></HorizontalBarChart>
                <div class="stats" slot="footer">
                </div>
            </el-tab-pane>
        </el-tabs>
        </card>
</template>
<script>
    import { StatsCard, ChartCard } from "@/components/dashboard/index";
    import BarChart from "@/components/dashboard/BarChart";
    import HorizontalBarChart from "@/components/dashboard/HorizontalBarChart";
    export default {
        name: "OpenRateRankingSection",
        props: {
            openRatioBar: Object,
            openQtyBar: Object,
        },
        components: {
            BarChart,
            ChartCard,
            HorizontalBarChart
        },
        methods: {
        },
        data() {
            return {
                tabRankName: "ratio"
            }
        }
    }
</script>
<style scoped>
    .align-end {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-end;
        align-items: center;
        align-content: center;
    }
    .pb-5p {
        padding-bottom: 5px;
    }
</style>